// extracted by mini-css-extract-plugin
export default {"chat":"chat_chat__fThst","popup":"chat_popup__4o5eY","fadeIn":"chat_fadeIn__zqmPf","providerError":"chat_providerError__ezSC3","anonymousInfo":"chat_anonymousInfo__nNC9S"};